import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { UserType } from '../../../types';
import { useAuthContext } from '../../../contexts/AuthContext';
import SwitchMobile from '../atomicDesignMobile/atoms/SwitchMobile';
import TextInputMobile from '../atomicDesignMobile/atoms/TextInputMobile';
import useLandingPageEmailParam from '../../../hooks/useLandingPageEmailParam';

const HomePageMobilePart = () => {
	const { t } = useTranslation();
	const {
		handleUserAuthentication,
		loadingSignin,
	} = useAuthContext();
	const {
		initialEmailFromQueryParam,
		hasValidEmailQueryParam,
		consumeEmailQueryParam,
	} = useLandingPageEmailParam();
	const [email, setEmail] = useState(initialEmailFromQueryParam);
	const [isPro, setIsPro] = useState(false);
	const navigate = useNavigate();
	
	useEffect(() => {
		if (isPro) {
			const timer = setTimeout(() => {
				navigate('/pro');
			}, 300);
			
			return () => clearTimeout(timer);
		}
	}, [isPro, navigate]);

	useEffect(() => {
		if (!hasValidEmailQueryParam) {
			return;
		}

		consumeEmailQueryParam();
		handleUserAuthentication(initialEmailFromQueryParam, UserType.PART);
	}, [
		consumeEmailQueryParam,
		handleUserAuthentication,
		hasValidEmailQueryParam,
		initialEmailFromQueryParam,
	]);
	
	const handleSubmit = (e: React.FormEvent) => {
		e.preventDefault();
		handleUserAuthentication(email, UserType.PART);
	};
	
	return (
		<div style={{ width: 390 }}>
			<div
				style={{
					width: 362,
					height: 462,
					margin: '0 14px',
					background: '#F6F8FB',
					borderRadius: 10,
					position: 'relative',
				}}
			>
				<div
					style={{
						position: 'absolute',
						width: 302,
						height: 52,
						top: 30,
						left: 31,
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<div style={{
						color: '#004D71',
						fontSize: 22,
						fontWeight: 500
					}}>
						{t('homePagePart:title')}
					</div>
					
					<div style={{
						color: '#61AFA1',
						marginTop: 10,
						fontSize: 13,
						fontWeight: 500,
						textTransform: 'uppercase'
					}}>
						{t('homePagePart:subtitle')}
					</div>
				</div>
				
				<SwitchMobile isPro={isPro} setIsPro={setIsPro} positionTop={108} />
				
				<form
					onSubmit={handleSubmit}
					style={{
						position: 'absolute',
						top: 186,
						left: 30,
						width: 303,
						height: 244,
						background: '#FFFFFF',
						boxShadow: '0px 1px 6px #0F4D0029',
						borderRadius: 10,
					}}
				>
					<div style={{ position: 'relative' }}>
						<div
							style={{
								position: 'absolute',
								top: 27,
								textAlign: 'center',
								fontWeight: 'bold',
								fontSize: 16,
								width: '100%',
								display: 'flex',
								justifyContent: 'center',
							}}
						>
							{t('page1:login_signup')}
						</div>
						<div
							style={{
								position: 'absolute',
								top: 55,
								left: 107,
								width: 87,
								height: 2,
								background: '#FF4D00',
							}}
						/>
						<div
							style={{
								position: 'absolute',
								top: 78,
								fontWeight: 500,
								fontSize: 12,
								width: '90%',
								padding: '0 5%',
								display: 'flex',
								textAlign: 'center',
							}}
						>
							{t('page1:enter_email')}
						</div>
						
						<div
							style={{
								position: 'absolute',
								top: 140,
								left: 20,
							}}
						>
							<TextInputMobile
								width={265}
								type="email"
								startIcon="@"
								placeholder="jean.dupont@gmail.com"
								value={email}
								onChange={(e) => setEmail(e.target.value.toLowerCase())}
								loading={loadingSignin}
							/>
						</div>
						
						<button
							type="submit"
							style={{
								position: 'absolute',
								top: 192,
								left: '50%',
								transform: 'translateX(-50%)',
								padding: '0px 20px',
								minHeight: 27,
								height: 'auto',
								borderRadius: 5,
								backgroundColor: '#FF4D00',
								color: '#FFFFFF',
								border: 'none',
								fontSize: 14,
								fontWeight: 600,
								cursor: 'pointer',
								textTransform: 'uppercase',
								fontFamily: 'Montserrat, sans-serif',
								whiteSpace: 'nowrap',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
							}}
						>
							{t('page1:button_text')}
						</button>
					</div>
				</form>
			</div>
		</div>
	);
};

export default HomePageMobilePart;
